@if ((phoneNumbers() && phoneNumbers().length > 0) || websiteUrl()) {
  <h2 class="text-2xl font-bold mb-2">Kontakt</h2>

  <div class="flex flex-col justify-start items-start">
    @if (websiteUrl()) {
      <div class="flex justify-start items-start gap-4 py-4">
        <app-ui-icon color="var(--grey-0)" name="website"
                  size="md"></app-ui-icon>
        <a
          class="inline-block"
          [eventAction]="'kundens webbsida'"
          [eventCategory]="'kundweb'"
          [eventLabel]="websiteUrl()"
          [eventParams]="customGa4Params()"
          [href]="websiteUrl()"
          appGtmEvent
          appGtmGa4Event
          rel="nofollow" target="_blank">{{ websiteUrl() | shortDomain }}</a>
      </div>
    }


    @if (phoneNumbers() && phoneNumbers().length > 0) {
      <div class="flex justify-start items-start gap-4 py-4">
        <app-ui-icon color="var(--grey-0)" name="phone"
                  size="md"></app-ui-icon>
        <div class="flex flex-col gap-4 justify-start items-start">
          @for (phone of phoneNumbers(); track phone.number) {
            <app-telephone
              [customGa4Params]="customGa4Params()"
              [label]="featureLabel()"
              [telephoneLabel]="phone.label"
              [telephoneNumber]="phone.number"
            ></app-telephone>
          }
        </div>
      </div>
    }
  </div>
}

